import axios from "infra/http";
import { useQuery } from "react-query";
import { UnidadeDashboardPessoaMorador } from "./typings/unidade";

function useUnidadePessoasDetalhes(id: string, pessoaId?: string | null) {
  return useQuery(
    `/v1/unidades/${id}/pessoas/historico/${pessoaId}`,
    async () => {
      const res = await axios.get<UnidadeDashboardPessoaMorador>(
        `/v1/unidades/${id}/pessoas/historico/${pessoaId}`
      );

      return res.data;
    },
    {
      enabled: !!pessoaId,
    }
  );
}

export default useUnidadePessoasDetalhes;
